<template>
  <body>
    <router-view/>
  </body>
</template>

<script>
import router from '@/router'
import {paths,} from '@/common/const'

export default {
  mounted() {
    document.addEventListener('keydown', this.resetTimeout);
    document.addEventListener('mousedown', this.resetTimeout);
  },
  methods: {
    resetTimeout() {
      clearTimeout(this.timeoutId);
      if (this.$store.state.token) {
        this.timeoutId = setTimeout(this.logout, this.timeoutMs);
      }
    },
    logout() {
      alert("一定時間画面操作が行われなかったため、ログアウトします。");
      this.$store.dispatch("removeToken");
      router.push({ path: paths.login, query: { redirect: this.$route.fullPath } });
    },
  },
  data(){
    return{
      timeoutMs: 1000 * 60 * 15, // 無操作タイムアウト時間（ミリ秒）
      timeoutId: "",
    }
  }
}
</script>
